import React from 'react';
import { Link } from 'react-router-dom';
import { PICKUP_STATUS_COLORS } from '../../../../constants/colors';
import { getTruckTypeColor } from '../../../../helpers/truckTypeColor';
import moment from 'moment';
import { truncateText } from '../../../../utils/tranceText';

const PickupCardContent = ({ pickup }) => {
  return (
    <div className="card-body">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-start mb-2">
        <Link
          to={`/pickups/${pickup.id}`}
          className="text-decoration-none fw-bold fs-5 text-blue"
        >
          Delivery #{pickup.id}
        </Link>
        <div className="small">
          <span
            className="badge"
            style={{
              backgroundColor:
                PICKUP_STATUS_COLORS[pickup.delivery_status?.id] || '#6c757d',
              padding: '6px 10px',
              fontWeight: 600,
              borderRadius: '8px',
              fontSize: '12px',
              letterSpacing: '0.2px',
            }}
          >
            {pickup.delivery_status?.status || 'No status'}
          </span>
        </div>

        <div className="fw-bold">${pickup.cost}</div>
      </div>

      <div
        className="mb-2 d-flex align-items-center"
        style={{ flexWrap: 'wrap', gap: '4px' }}
      >
        {pickup.origins.length >= 2 && (
          <div className="badge bg-primary">Multiple pickup</div>
        )}
        {pickup.truck_type && (
          <span
            className="badge"
            style={{
              backgroundColor: getTruckTypeColor(pickup.truck_type.title),
              color: '#fff',
            }}
          >
            {pickup.truck_type.title}
          </span>
        )}
        {!pickup.waiting_for_driver_at && (
          <span
            className="badge bg-danger "
            style={{
              color: '#fff',
            }}
          >
            Unpaid
          </span>
        )}
      </div>
      {/* CUSTOMER */}
      <div className="mb-2 d-flex justify-content-between align-items-center ">
        <div>
          <p className="small text-muted mb-0">Customer</p>

          <p className="mb-0">{pickup.user?.full_name || 'Unknown'}</p>
        </div>

        <div>
          <p className="small text-muted mb-0">Driver</p>

          <p className="mb-0">
            {truncateText(pickup.driver?.name || 'Unassigned', 20)}
          </p>
        </div>
      </div>

      {pickup.scheduled_pickup_time && (
        <div className="mb-2">
          <p className="small text-muted mb-1">
            Schedule:{' '}
            <span className="text-dark">
              {moment(pickup.scheduled_pickup_time).format('YYYY-MM-DD h:m A')}
            </span>{' '}
          </p>
        </div>
      )}
      {/* ADDRESSES */}
      <div className="mb-2">
        <div className="small text-muted mb-2">Route</div>

        <div className="d-flex flex-column gap-2 mb-1 ">
          {(pickup.origins || []).map((origin, index) => (
            <React.Fragment key={origin.id || index}>
              {/* PICKUP */}
              <div
                className="p-2 mb-1"
                style={{
                  background: '#f0fdf4',
                  borderRadius: '10px',
                  border: '1px solid #bbf7d0',
                }}
              >
                <div
                  className="fw-semibold small"
                  style={{
                    color: '#198754',
                  }}
                >
                  Pickup #{index + 1}
                </div>

                <div className="small mt-1">
                  {truncateText(origin.address || '', 60)}
                </div>
              </div>
              {/* DROPOFF */}
              {(pickup.dropoffs || [])[index] && (
                <div
                  className="p-2 mb-2"
                  style={{
                    background: '#fef2f2',
                    borderRadius: '10px',
                    border: '1px solid #fecaca',
                  }}
                >
                  <div
                    className="fw-semibold small"
                    style={{
                      color: '#dc3545',
                    }}
                  >
                    Dropoff #{index + 1}
                  </div>

                  <div className="small mt-1">
                    {truncateText(pickup.dropoffs[index].address || '', 60)}
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      {/* FOOTER */}
      <div className="border-top pt-2 mt-2">
        <div className="d-flex justify-content-between small">
          <p className="text-muted mb-0 text-center">
            Distance: <br /> <span>{pickup.distance} km</span>
          </p>
          <p className="text-muted mb-0 text-center">
            Created: <br />
            <span>{moment(pickup.created_at).format('YYYY-MM-DD')}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PickupCardContent;
